module.exports = __webpack_public_path__ + "img/Delete Icon - charcoal.562d7c41.svg";